//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, EventEmitter, Inject, Output } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { D3eService } from '../../../../services/d3e-service';
import { NotificationService } from '../../../../services/notification-service';
import { TranslateService } from '@ngx-translate/core';
import { CustomValidators } from '../../../shared/validators/custom-validators';

export interface IAddPbaSerialData {
  subscriptionId: string;
  selectedOrgId: string;
}

@Component({
    selector: 'app-add-ssd-serial-dialog',
    templateUrl: './add-ssd-serial-dialog.component.html',
    styleUrls: ['./add-ssd-serial-dialog.component.scss'],
    standalone: false
})
export class AddSsdSerialDialogComponent {
  form: UntypedFormGroup;
  @Output() serialSubmitted = new EventEmitter<string[]>();

  adding = false;

  error_occurred: string = null;
  badSerials: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: IAddPbaSerialData,
              private readonly formBuilder: UntypedFormBuilder,
              private readonly dialogRef: MatDialogRef<AddSsdSerialDialogComponent>,
              private readonly d3eService: D3eService,
              private notification: NotificationService,
              private translate: TranslateService) {
    this.form = this.formBuilder.group({
      serial: ['', [Validators.required, CustomValidators.uniqueSerialsValidator()]]
    });
  }

  addSerial(newSerialText: string, notify=false) {
    this.adding = true;
    this.error_occurred = null;
    this.d3eService.addPbaSerial(this.data.selectedOrgId, this.data.subscriptionId, newSerialText).subscribe(response => {
      if (response.success) {
        this.serialSubmitted.emit(response.new_serials);
        this.adding = false;
        this.form.reset();
        if (notify) {
          this.notification.showSuccess(this.translate.instant('assign-licenses-add-ssd-serial-dialog.serial-added'));
          this.dialogRef.close();
        }
      } else {
        if ( (response.bad_serials || []).length > 0) {
          this.badSerials = [];
          switch (response.status) {
            case 'duplicate-serials':
              this.error_occurred = 'assign-licenses-add-ssd-serial-dialog.already-exists';
              this.badSerials = response.bad_serials;
              break;
            case 'serials-too-long':
              this.error_occurred = 'assign-licenses-add-ssd-serial-dialog.invalid-serial-length';
              this.badSerials = response.bad_serials;
              break;
            default:
              this.error_occurred = 'ERROR_OCCURRED_UNKNOWN';
              break;
          }
        }
      }
    },
      () => {
      this.adding = false;
      this.error_occurred = 'ERROR_OCCURRED_UNKNOWN';
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick() {
    this.addSerial(this.form.value.serial, true);
  }

  onSaveAndAddAnotherClick() {
    if (this.form.value.serial != null &&
        this.form.value.serial.length ) {
        this.addSerial(this.form.value.serial, false);
    }
  }

}
